import './env.model';

export const environment = {
  protocol: window.__env?.protocol ?? 'http',
  apiUrl: window.__env?.apiUrl ?? 'localhost',
  port: window.__env?.port ?? '8080',

  production: ['true', '1', 'yes'].includes(
    String(window.__env?.production).toLowerCase()
  ),

  appName: window.__env?.appName ?? '',

  debug: ['true', '1', 'yes'].includes(
    String(window.__env?.debug).toLowerCase()
  ),

  secretKey: 'WIiOiIxMjM0NTY3ODkwIiwibmFtZ',

  stripe: {
    publicKey:
      'pk_test_51PLHHNSDuguvJYJa9K8NaQ05NCohHREKIYV00wjG7xFfVYkbYAbajWRcHxmq5mkEJKCVcfBzRhm9RDiVInIm5W9D00psJWj24u'
  }
};

// export const environment = {
//   protocol: 'http',
//   apiUrl: 'localhost',
//   port: '8080',

//   production: false,

//   appName: 'Absence Assistance',

//   debug: false,

//   secretKey: 'WIiOiIxMjM0NTY3ODkwIiwibmFtZ',

//   stripe: {
//     publicKey:
//       'pk_test_51PLHHNSDuguvJYJa9K8NaQ05NCohHREKIYV00wjG7xFfVYkbYAbajWRcHxmq5mkEJKCVcfBzRhm9RDiVInIm5W9D00psJWj24u'
//   }
// };
